import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

export const DOC = gql`
  ${fragments.message.DOC}

  query AgentChatMessages($tenantId: ID!, $zoneId: ID!, $conversationId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        agentChatMessages(conversationId: $conversationId) {
          ...FragmentAgentChatMessage
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.AgentChatMessagesQuery,
    readonly ents.core.agent.Message.WithInfo[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'agentChatMessages',
        graphql.transformers.OUT.list(fragments.message.TRANSFORMER, {
          onNullish: 'remove',
        }),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.AgentChatMessagesQuery,
  readonly ents.core.agent.Message.WithInfo[],
  graphql.schema.AgentChatMessagesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
